import * as styles from './index.css'

export const Banner = (props: {
  type: 'PLAY_WITH_FRIENDS' | 'PLAY_WITH_FRIENDS_2' | 'PLAY_WITH_FRIENDS_3'
  onClick?: () => void
}) => {
  return (
    <img
      src='/banners/play_with_friends_3.png'
      alt='Play with you friends. Click to start creating a room'
      className={styles.banner}
      onClick={props.onClick}
      onKeyDown={props.onClick}
    />
  )
}
